import { render, staticRenderFns } from "./DeliveryJob.vue?vue&type=template&id=0688045d&scoped=true&"
import script from "./DeliveryJob.vue?vue&type=script&lang=js&"
export * from "./DeliveryJob.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryJob.vue?vue&type=style&index=0&id=0688045d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688045d",
  null
  
)

export default component.exports